import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-permit-settings-header',
    templateUrl: './permit-settings-header.component.html',
    styleUrls: ['./permit-settings-header.component.scss'],
})
export class PermitSettingsHeaderComponent {
    @Input() title: string;

    @Input() showBackButton = false;

    @Input() showCreateButton = false;

    @Input() createButtonTranslationKey = '';

    /** Secondary action, shown to the left of the create button. */
    @Input() showSyncButton = false;

    @Input() syncButtonTranslationKey = '';

    @Output() back = new EventEmitter<void>();

    @Output() create = new EventEmitter<void>();

    @Output() sync = new EventEmitter<void>();

    onBack(): void {
        this.back.emit();
    }

    onCreate(): void {
        this.create.emit();
    }

    onSync(): void {
        this.sync.emit();
    }
}
